import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LinkButton from './LinkButton';
import { t } from '../../../config/i18n';

const DownloadButton = ({ text = 'labelDownloadVoucher', downloadAction }) => {
  const [downloadInProgress, setDownloadInProgress] = useState(false);

  const handleClick = async () => {
    setDownloadInProgress(true);
    await downloadAction();
    setDownloadInProgress(false);
  };

  return (
    <LinkButton className="download-receipt" disabled={downloadInProgress} onClick={handleClick}>
      {downloadInProgress && <FontAwesomeIcon icon={{ prefix: 'far', iconName: 'spinner-third' }} size="lg" spin className="mx-2" />}
      <FontAwesomeIcon color="black" icon={{ iconName: 'download', prefix: 'fal' }} />
      <span className="file-link">{t(text)}</span>
    </LinkButton>
  );
};

export default DownloadButton;
